export default __webpack_public_path__ + "b992fe6e9c5ccade2115126f1405cccc.png";